// PagaCon — strip "Pagás con [MP] o 🏦 Transferencia · 🔒 Cifrado SSL".
// Fuente: maquetas (kit-detalle / producto-detalle). Logo MP sobre chip #FFE600. Sin estado.
//
// Self-contained: <style>{PC_CSS}</style> + clases .tv5-pc-* + tokens --tv5-* propios.
// Requiere el asset /mp-logo.svg en public/ (copiado desde deploy_v5/assets).
//
// Props:
//   transferencia  boolean  → muestra "🏦 Transferencia" (default true).
//                             En flujo suscripción (solo tarjeta recurrente) va en false.
//   ssl            boolean  → muestra el sello "🔒 Cifrado SSL" (default true)

const PC_CSS = `
.tv5-pc {
  --tv5-text:#F8F6F1; --tv5-muted:rgba(248,246,241,0.65); --tv5-dim:rgba(248,246,241,0.45);
  --tv5-border:rgba(255,255,255,0.08);
  display:flex; align-items:center; gap:10px; flex-wrap:wrap; font-size:12px;
  color:var(--tv5-muted); margin-top:14px;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
}
.tv5-pc-lbl { font-weight:600; letter-spacing:0.01em; }
.tv5-pc-mp { display:inline-flex; align-items:center; padding:2px 6px; background:#FFE600;
  border-radius:5px; box-shadow:0 4px 14px rgba(255,230,0,0.28); }
.tv5-pc-mp img { height:28px; display:block; }
.tv5-pc-o { color:var(--tv5-dim); font-size:12px; font-weight:600; }
.tv5-pc-tr { display:inline-flex; align-items:center; gap:5px; padding:6px 12px;
  background:rgba(255,255,255,0.06); border:1px solid var(--tv5-border); border-radius:8px;
  font-weight:700; font-size:11px; color:var(--tv5-text); }
.tv5-pc-ssl { margin-left:auto; font-size:10px; color:var(--tv5-dim); display:inline-flex; align-items:center; gap:4px; }
.tv5-pc-ssl::before { content:'🔒'; }
`;

export function PagaCon({ transferencia = true, ssl = true }) {
  return (
    <div className="tv5-pc">
      <style>{PC_CSS}</style>
      <span className="tv5-pc-lbl">Pagás con</span>
      <span className="tv5-pc-mp"><img src="/mp-logo.svg" alt="Mercado Pago" /></span>
      {transferencia && (
        <>
          <span className="tv5-pc-o">o</span>
          <span className="tv5-pc-tr">🏦 Transferencia</span>
        </>
      )}
      {ssl && <span className="tv5-pc-ssl">Cifrado SSL</span>}
    </div>
  );
}
